import { alpha } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export const MuiToggleButtonConfig = {
    defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
        size: 'medium',
    },
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                '.toggle-button--mod-light &': {
                    backgroundColor: theme.palette.background.default,
                },
                '&:focus': {
                    outline: 'none',
                },
                '&:hover, &.Mui-selected:hover': {
                    borderColor: alpha(theme.palette.text.primary, 0.24),
                    backgroundColor: alpha(theme.palette.text.primary, 0.04),
                    color: alpha(theme.palette.text.primary, 0.8),
                    '.design-variant--secondary &': {
                        backgroundColor: 'transparent',
                        color: theme.palette.primary.main,
                    },
                },
                '&:active, &.Mui-selected:active': {
                    borderColor: alpha(theme.palette.text.primary, 0.4),
                    backgroundColor: alpha(theme.palette.text.primary, 0.16),
                    color: alpha(theme.palette.text.primary, 0.64),
                    '.design-variant--secondary &': {
                        backgroundColor: 'transparent',
                        color: theme.palette.primary.main,
                    },
                },
                '&.Mui-selected:not(.Mui-disabled):hover, &.Mui-selected:active': {
                    '.design-variant--secondary &': {
                        backgroundColor: theme.palette.background.default,
                        color: alpha(theme.palette.primary.main, 0.8),
                    },
                },
                '&.Mui-selected': {
                    fontWeight: 600, //todo review it. can jump
                    backgroundColor: 'transparent',
                    '.toggle-button--mod-light &': {
                        backgroundColor: useBlendColors(
                            alpha(theme.componentSettings.primaryButton.primaryColor, 0.08),
                        ),
                        zIndex: 1,
                    },
                    '.design-variant--secondary &': {
                        backgroundColor: theme.palette.background.default,
                        boxShadow: `0px 1px 4px 0px ${alpha(theme.palette.text.primary, 0.12)}`,
                        borderRadius: '3px',
                    },
                },
                '&.Mui-disabled': {
                    color: alpha(theme.palette.text.primary, 0.24),
                    borderColor: alpha(theme.palette.text.primary, 0.24),
                    '&.MuiToggleButtonGroup-grouped:not(:hover)': {
                        borderColor: useBlendColors(alpha(theme.palette.text.primary, 0.24)),
                    },
                    '.design-variant--secondary &': {
                        color: alpha(theme.palette.text.primary, 0.4),
                    },
                },
                '&.Mui-selected.Mui-disabled': {
                    color: alpha(theme.palette.text.primary, 0.55),
                    borderColor: alpha(theme.palette.text.primary, 0.55),
                    '&.MuiToggleButtonGroup-grouped:not(:hover)': {
                        borderColor: useBlendColors(alpha(theme.palette.text.primary, 0.55)),
                        zIndex: 1,
                    },
                },
                '&.Mui-selected:not(.Mui-disabled)': {
                    color: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                    '&.MuiToggleButtonGroup-grouped:not(:hover)': {
                        borderLeftColor: theme.palette.primary.main,
                        zIndex: 1,
                    },
                    '.design-variant--secondary &': {
                        color: theme.palette.primary.main,
                    },
                },
            };
        },
        sizeMedium: ({ theme }: { theme: any }) => {
            return {
                padding: '4px 12px',
                minHeight: theme.size.defaultHeight,
                color: theme.palette.text.primary,
                borderColor: alpha(theme.palette.text.primary, 0.4),

                '.design-variant--secondary &': {
                    padding: '2px 6px',
                    minHeight: '22px', //minHeight - group padding
                    color: alpha(theme.palette.text.primary, 0.8),
                    border: '0 !important',
                },
            };
        },
    },
};
